import React, { createContext, useContext, useEffect, useState } from 'react';
import { adminUser } from './sample';
import { notification } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { loginReset } from './redux/slice/login/loginSlice';
import { user, userReset } from './redux/slice/user/userSlice';
import { useNavigate } from 'react-router-dom';
const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [userData, setUser] = useState({
    ...adminUser, // Import or define adminUser here
  });
  // const [userData, setUser] = useState(null);
  const dispatch = useDispatch();
  const loginState = useSelector((state) => state.loginState);
  const userState = useSelector((state) => state.userState);
  const navigate = useNavigate();

  useEffect(() => {
    if (loginState.status === 'success') {
      notification.success({
        message: 'Welcome!',
        description: loginState.message,
        duration: 3,
      });
      localStorage.setItem('token', JSON.stringify(loginState.token));
      dispatch(user());
      dispatch(loginReset());
      navigate('/');
    } else if (loginState.status === 'error') {
      notification.error({
        message: 'Error',
        description: loginState.message,
        duration: 3,
      });
    }
  }, [loginState]);

  useEffect(() => {
    if (userState.status === 'success') {
      // setUser(userState.data[0]);
      // dispatch(userReset());
    }
  }, [userState]);

  useEffect(() => {
    let token = localStorage.getItem('token');
    if (token) {
      dispatch(user());
    } else {
      navigate('/login');
    }
  }, []);

  const hasPermission = (module, scope) => {
    // if (userData) {
    //   const access = userData.access.find((m) => m.module === module);
    //   if (access && access?.scope) {
    //     let scopes = access?.scope.split(',');
    //     return scopes.includes(scope);
    //   }
    // }
    const access = userData.roleAndAccess.find((m) => m.module === module);
    return access?.scope.includes(scope);
  };

  return <AuthContext.Provider value={{ userData, hasPermission }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
